import { useAuth } from '@clerk/clerk-react';
import { useState, useEffect } from 'react';

export function useToken() {
    const { getToken } = useAuth();
    const [token, setToken] = useState(null);

    useEffect(() => {
        let mounted = true;
        getToken().then(t => {
            if (mounted) setToken(t);
        });
        return () => {
            mounted = false;
        };
    }, [getToken]);

    return token;
}

export default useToken;
